module.exports = __webpack_public_path__ + "img/feldberg-7338.155ffd72.jpeg";